import { useState, useEffect } from "react";
import { fetchParentListAction } from "../actions/fetchParentListAction";

/**
 * Shared hook — fetches parent company list and returns dropdown options.
 *
 * Option shape: { value: parentCode, label: parentName }
 *
 * Used by:
 *  - CreateNew form (ClientData.js)
 *  - EditClientModal (EditDetailsData.js)
 */
export const useParentOptions = () => {
  const [parentOptions, setParentOptions] = useState([
    { value: "", label: "Select parent company" },
  ]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchParentListAction()
      .then((result) => {
        if (result.success && result.data.length > 0) {
          setParentOptions([
            { value: "", label: "Select parent company" },
            ...result.data.map((r) => ({
              value: r.parentCode || "",
              label: r.parentCode
                ? `${r.parentCode} - ${r.parentName || r.parentCode}`
                : r.parentName || "",
            })),
          ]);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return { parentOptions, loading };
};
